/**
 * ¿El veredicto de underwriting native es un rechazo? ms-agl devuelve la decisión en
 * minúsculas (`accepted` / `rejected`). El funnel comparaba con "REJECTED" y dejó
 * pasar al pago a clientes rechazados por el cuestionario médico (04-11-2026): se
 * compara sin distinguir mayúsculas.
 */
export const isRejectedVerdict = (decision: unknown): boolean =>
  "rejected" === String(decision ?? "").trim().toLowerCase();
